<div class="btn-loading-colibri" *ngIf="typeLoading == COMPONENT_LOADING">
    <img src="./assets/images/loading_component.gif">
</div>

<div class="btn-loading-footer-colibri" *ngIf="typeLoading == FOOTER_LOADING">
    <img src="./assets/images/loading.gif">
</div>

<div *ngIf="blockScreen"  class="bg-loading-colibri" ></div>